import styled, { css } from 'styled-components';

import colors from '@/design/colors';
import { HeadingSmall, Text } from '@/design/typography';

interface StyledProps {
  hasError: boolean;
}

export const Title = styled.label`
  ${HeadingSmall(14)};
  color: ${colors.blackAlpha200};
  margin-bottom: 8px;
`;

export const HelperText = styled.span`
  ${Text(14)};
  color: ${colors.gray200};
  margin-top: 4px;
`;

const SelectMixin = css`
  ${Text(16)};
  width: 100%;

  color: ${colors.blackAlpha200};
  padding: 8px;
  border: 1px solid ${colors.gray100};
  border-radius: 8px;

  transition-property: color, background-color, border-color, box-shadow;
  transition-duration: 200ms;
  transition-timing-function: ease-in;

  &:focus:not(:disabled):not([data-read-only='true']) {
    border-color: ${colors.purple100};
  }

  &:disabled {
    color: ${colors.gray200};
    background-color: ${colors.gray50};
    cursor: not-allowed;
  }

  &[data-read-only='true'] {
    background-color: ${colors.gray50};
    cursor: default;
  }
`;

export const Field = styled.div<StyledProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${props =>
    props.hasError &&
    css`
      > ${HelperText} {
        color: ${colors.red100};
      }

      button {
        border-color: ${colors.red100};

        &:focus:not(:disabled):not([data-read-only='true']) {
          border-color: ${colors.red100};
        }
      }
    `}
`;

export const InputContent = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

interface SelectButtonProps {
  opened: boolean;
}

export const SelectButton = styled.button<SelectButtonProps>`
  ${SelectMixin};

  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;

  background-color: ${colors.white};

  ${props =>
    props.opened &&
    css`
      border-color: ${colors.purple100};
    `}
`;

export const SelectLabel = styled.span`
  display: block;
  min-width: 0;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SelectIcon = styled.span`
  display: flex;
  margin-left: 8px;
`;

export const SelectDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;

  width: 100%;
  z-index: 1000;
`;
